export function convertBytesToString(value?: string | number) {
  const { bytesToSize } = window.tcbase || {};
  if (bytesToSize) {
    return bytesToSize(value ?? 0);
  }
  return value;
}

type Props = {
  value?: string | number;
  showBytes?: boolean;
};

const FileSize = ({ value, showBytes = false }: Props) => (
  <>
    {convertBytesToString(value)} {showBytes && `(${value} B)`}
  </>
);

export default FileSize;
